import React from "react";
import { useSelector } from "react-redux";
import NotificationBell from "@components/Notification/NotificationBell";
import { useTranslation } from "react-i18next";
import Profile from "@features/Profile/Profile";
import type { RootState } from "@store/store";

const Header = React.memo(() => {
	const { t } = useTranslation();
	const user = useSelector((state: RootState) => state.user.user);

	const getPortalTitle = () => {
		const firstName = user?.firstName || "";
		const lastName = user?.lastName || "";
		const title = t("title");

		// If we have both firstName and lastName, concatenate title with name
		if (firstName && lastName) {
			return `${title} - ${firstName} ${lastName}`;
		}
		// If we only have firstName
		if (firstName) {
			return `${title} - ${firstName}`;
		}
		// Fallback to just title
		return title;
	};

	return (
		<header className="sticky top-0 z-30 flex items-center justify-between bg-gradient-to-r from-white to-gray-50 px-8 py-5 shadow-md border-b border-gray-100 ml-72 backdrop-blur-sm">
			<div className="flex items-center gap-4">
				<span id="project-title" className="text-2xl font-semibold text-gray-900 tracking-tight">
					{getPortalTitle()}
				</span>
			</div>
			<div className="flex items-center gap-4">
				<div className="w-12 h-12 bg-gray-100 rounded-full flex items-center justify-center">
					<NotificationBell />
				</div>
				<Profile />
			</div>
		</header>
	);
});

export default Header;
